const initialState = {
    isReadingQuotesAndOrders: false,
    entries: [],
    count: 0,

    isReadingQuotesAndOrdersPowerSelectors: false,
    quotesAndOrdersPowerSelectors: []
}

export default initialState;
